export var HEADER_NAVIGATION_SEARCH_CLASS_PREFIX = 'HeaderNavigationSearch';
export var headerNavigationSearchRoot = 'HeaderNavigationSearchRoot';